import { useContext } from 'react';
import { Box, Typography } from '@mui/material'
import { AuthContext } from '../../../contexts/auth/authContext'
import { DataContext } from '../../../contexts/data/dataContext'
import custom from '../../../styles/mui/szVariables.json'

export default function ImpersonationBar() {
    const auth = useContext(AuthContext)
    const data = useContext(DataContext)

    const handleEndSession = ()=> {
        auth?.signOut(window.close)
      }

    return (
        <Box maxWidth={"100%"} display="flex"
             justifyContent={"flex-start"} flexDirection={"row"}>
        {auth?.staff && <>
            <Box height="27px" 
                width={data?.rightPanel?"calc(100vw - 400px)":"99.3%"} 
                // maxWidth={"1200px"}
                position={"fixed"} 
                top={73} 
                sx={{
                    backgroundColor: '#000', 
                    color: '#FFF',
                }}
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"space-between"}>
            {data?.customer &&   <>
                <Typography 
                        mt={custom.spacing.xxs}
                        ml={custom.spacing.md} 
                        // pr={"80px"}
                        textAlign={"center"}
                        color='#FFF'
                        variant="szBody.Regular.xxSmall" 
                        id="staffName">
                        {auth?.staff?.split('::')[0]} you're viewing as {data?.customer?.name} ({data?.customer?.account.siteId})
                </Typography>
                <Box display="flex" 
                        mt={custom.spacing.xxs}
                        flexDirection={"row"}
                        justifyContent={"center"}
                        alignItems={"center"}
                        onClick={handleEndSession}                        
                        sx={{ 
                            mr: custom.spacing.md,
                            backgroundColor: 'error.main',
                            height: '16px',
                            borderRadius: 1,
                            cursor: 'pointer'
                        }} 
                        id="staffLogout">
                        <Typography
                            px={custom.spacing.xxs}
                            color='#FFF'
                            variant="szBody.Regular.xxSmall" 
                            id="staffName">
                        End session
                    </Typography>
                </Box>
            </>}
            </Box>
            <Box display={data?.rightPanel?'block':'none'} 
            width={{ 
                xs: 0, 
                sm: 0, 
                md: 0, 
                lg: '400px', 
                xl: '400px' }}
            />
            </>
        }     
        </Box>
    )
}